// extracted by mini-css-extract-plugin
export var logo = "_bk-2";
export var logoWrapper = "_bk-1";
export var strip = "_bk-0";